








































import { Vue, Component } from "vue-property-decorator";
import Axios from "axios";
import store from "../store";

@Component
export default class Products extends Vue {
  products = [];
  form = {
    Id: "",
    Produto: "",
    Cfop: "",
    Ncm: "",
    Cson: ""
  };
  formUp = false;

  beforeCreate() {
    Axios.get(`https://api.clubdobalanco.com/v1/taxes`, {
      headers: { Authorization: store.state.passwd }
    }).then(r => (this.products = r.data));
  }
}
